<template>
  <div class="text-h5" style="margin-bottom: 44px;">
    Счет № {{ bill_id }}
  </div>
  <div class="row">
    <div class="col-7 q-ma-lg">
      <div class="text-h5">
        Информация
      </div>
      <div class="q-pa-md">
        <q-input v-model="name" label="Название счета" />
      </div>
      <div class="q-pa-md">
        <q-toggle v-model="is_material_bill" label="Материальный счет"/>
      </div>
      <div class="q-pa-md">
        <q-toggle v-model="is_out_of_balance_bill" label="Забалансный счет"/>
      </div>
      <q-separator class="q-ma-md"/>
      <div class="text-h5">
        Фильтры по полям для аналитики
      </div>
      <div class="q-pa-md">
        <q-option-group
            v-model="filter_documents_by"
            :options="filter_options"
            type="toggle"
        />
      </div>
      <div class="col-7 q-ma-lg">
        <q-btn icon="save" flat label="Сохранить" @click="saveBill"/>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {apiUrl} from "../../config";
import {ref} from "vue";

export default {
  name: "bill_edit",
  data() {
    if (this.$route.params.id) {
      const data = {
        id: this.$route.params.id
      }
      axios
          .post(apiUrl + '/admin/bills/info/', data, {auth: this.$store.state.credentials})
          .then((response) => {
            const data = response.data.item;
            console.log(data);
            this.name = data.name;
            this.bill_id = data.bill_id;
            this.is_material_bill = data.is_material_bill;
            this.is_out_of_balance_bill = data.is_out_of_balance_bill;
            this.filter_documents_by = data.filter_documents_by;
          });
      axios
          .post(apiUrl + '/admin/documents/fields/list/', {}, {auth: this.$store.state.credentials})
          .then((response) => {
            this.filter_options = response.data.items;
          });
    }
    return {
      bill_id: ref(null),
      name: ref(''),
      is_material_bill: ref(false),
      is_out_of_balance_bill: ref(false),
      filter_documents_by: ref([]),
      filter_options: ref([])
    }
  },
  methods: {
    saveBill() {
      this.$q.loading.show();
      const data = {
        id: this.$route.params.id,
        bill_id: this.bill_id,
        name: this.name,
        is_material_bill: this.is_material_bill,
        is_out_of_balance_bill: this.is_out_of_balance_bill,
        filter_documents_by: this.filter_documents_by,
      }
      axios
          .post(apiUrl + '/admin/bills/save/', data, {auth: this.$store.state.credentials})
          // eslint-disable-next-line no-unused-vars
          .then((response) => {
            this.$q.loading.hide();
          });
    }
  }
}
</script>

<style scoped>

</style>